import { useContext } from 'react';
import { ColorModeContext } from '../app/theme';
import { designTheme } from '../styles/designTheme';

export function useDesignTheme() {
  const { mode } = useContext(ColorModeContext);
  const theme = mode === 'dark' ? designTheme.dark : designTheme.light;
  return { theme, isDark: mode === 'dark', mode };
}
